/* eslint-disable */
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// Chakra imports
import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { ENDPOINTS } from "utils/Constants";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
import { notify } from "components/ToastNotification";
// Assets
import illustration from "assets/img/auth/auth.png";

function ForgotPassword() {
    // Chakra color mode
    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";

    const navigate = useNavigate();

    const [formData, setFormData] = React.useState({
        email: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emptyFields = Object.keys(formData).filter((key) => !formData[key].trim());
        if (emptyFields.length > 0) {
            notify(`Please fill in all fields: ${emptyFields.join(", ")}`, "warning");
            return;
        }

        try {
            const response = await axios.post(ENDPOINTS.FORGOT_PASSWORD, formData);
            const responseData = response.data;
            notify(responseData.output, responseData.success ? 'success' : 'error');
            if (responseData.success) {
                setFormData({ email: '' });
            }
        } catch (error) {
            if (error.response?.data) {
                const response = error.response?.data;
                notify(response.output, response.success ? 'success' : 'error');
            }
        }
    };



    return (
        <DefaultAuth illustrationBackground={illustration} image={illustration}>
            <Flex
                maxW={{ base: "100%", md: "max-content" }}
                w='100%'
                mx={{ base: "auto", lg: "0px" }}
                me='auto'
                h='100%'
                alignItems='start'
                justifyContent='center'
                mb={{ base: "30px", md: "60px" }}
                px={{ base: "25px", md: "0px" }}
                mt={{ base: "40px", md: "14vh" }}
                flexDirection='column'>
                <Box me='auto'>
                    <Heading color={textColor} fontSize='36px' mb='10px'>
                        Forgot password?
                    </Heading>
                    <Text
                        mb='36px'
                        ms='4px'
                        color={textColorSecondary}
                        fontWeight='400'
                        fontSize='md'>
                        Enter your email!
                    </Text>
                </Box>
                <Flex
                    zIndex='2'
                    direction='column'
                    w={{ base: "100%", md: "420px" }}
                    maxW='100%'
                    background='transparent'
                    borderRadius='15px'
                    mx={{ base: "auto", lg: "unset" }}
                    me='auto'
                    mb={{ base: "20px", md: "auto" }}>

                    <form onSubmit={handleSubmit}>
                        <FormControl>
                            <Input
                                isRequired={true}
                                variant='auth'
                                fontSize='sm'
                                ms={{ base: "0px", md: "0px" }}
                                type='email'
                                placeholder='Email*'
                                mb='24px'
                                fontWeight='500'
                                size='lg'
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            <Button
                                fontSize='sm'
                                variant='brand'
                                fontWeight='500'
                                type="submit"
                                w='100%'
                                h='50'
                                mb='24px'>
                                Send
                            </Button>
                        </FormControl>
                    </form>
                </Flex>
            </Flex>

        </DefaultAuth >
    );
}

export default ForgotPassword;
